import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getAllPayers(activeOnly) {
    return fetchQuery("GetAllPayers", {
        activeOnly
    });
}